import React, { useState, useEffect }  from 'react'
import {config} from '../config'
import Modal from 'react-bootstrap/Modal'
import * as txApi from '../clients/tx-sls-client'


const txdomain = config()['tourneyx-url']
const linodeurl = config()['linode-url']


const TeamStandingsAngler = ({angler,user_information, hideProfileLink = false}) => {
 //If linodeoption is 1 image load from linode and 0 image load from server.
 const [linodeoption,setLinodeoption] = useState('');
 useEffect(() =>{
     txApi.getImageSourceOption('load_images_from_linode').then((response)=>{
         setLinodeoption(response);
        })
 },[]);
 if(angler.hasOwnProperty("angler_name")) {
    var {user_photo, angler_name, angler_state, is_member, is_logged_in, angler_login,user_id,angler_team,angler_country} = angler
  }
  const imgError = (event) => event.target.src = '/leaderboard/green28x.png'

  const getAvatar = (image, name) => {
    
    if(linodeoption != '' && linodeoption == 1){
      return image 
      ? <img
          onError={imgError}
          src={`${linodeurl}/angler_uploads/` + 
          image} className="angler_avatar" alt='{name}'/> 
      : 
      <div className="ai-icon">{name.split(" ").map((n)=>n[0]).join(".")}</div> 
    }else{

      return image 
      ? <img
          onError={imgError}
          src={`${txdomain}/app/lib/php/timthumb.php?src=${txdomain}/app/lib/uploads/angler_uploads/` + 
          image + '&amp;h=50&amp;w=50&amp;zc=1'} className="angler_avatar" alt='{name}'/> 
      : 
      <div className="ai-icon">{name.split(" ").map((n)=>n[0]).join(".")}</div> 
    }
    
         
      

      
  }

  if(angler.hasOwnProperty("angler_name")) {
    var angleDisplay = 
    <>
      <div className="ang-img-container left">  
        {getAvatar(user_photo, angler_name)}
        {is_logged_in === "1" ? <span className="logged_in_dot"></span> : <span/>}
      </div>
      
      
      {
         (user_information && user_information.role === '1') ?

        <div>
            {(is_member === "1" || is_member === 1 ) ? <img src="/leaderboard/X.png" alt="TourneyX" className="stats"/> : <span/>}
            <span className="angler-name">{angler_name}&nbsp;({user_id}) </span>
        </div>
        :
        <div>
            {(is_member === "1" || is_member === 1 ) ? <img src="/leaderboard/X.png" alt="TourneyX" className="stats"/> : <span/>}
            <span className="angler-name">{angler_name}</span>
        </div>

      }



      <div><small>{angler_state && angler_country ? `(${angler_state}, ${angler_country})` : ''}</small></div>
      <div><small>{angler_team ? `${angler_team}` : ''}</small></div>
    </>
  }
 

  return(
    <td className="standings-angler">
      {
        !hideProfileLink 
          ? <a href={`${txdomain}/app/profile/` + angler_login}>{angleDisplay}</a>
          : <> {angleDisplay} </>
      }
    </td>
  )
}

export default TeamStandingsAngler